module.exports = __webpack_public_path__ + "static/media/facebook_orange.024b5923.svg";